<template>
  <MfaDetail />
</template>
<script>
import MfaDetail from "@/components/utils/MfaDetail.vue"

export default {
  components: {
    MfaDetail
  },
  data() {
    return {
      invalidKey: false,
      temp_token: this.$route.query.temp_token
    }
  }
}
</script>
